"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteNode = void 0;
var helpers_1 = require("./helpers");
var RouteNode = /** @class */ (function () {
    function RouteNode(_a) {
        var _b = _a.shared, shared = _b === void 0 ? {} : _b, _c = _a.routes, routes = _c === void 0 ? [] : _c, _d = _a.children, children = _d === void 0 ? [] : _d;
        this.merged = false;
        this.shared = shared;
        this.routes = routes;
        this.children = children;
    }
    RouteNode.prototype[Symbol.iterator] = function () {
        var _a, basePath, meta, _b, _c, route, e_1_1, _d, _e, child, e_2_1;
        var e_1, _f, e_2, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _a = this.shared, basePath = _a.basePath, meta = _a.meta;
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 6, 7, 8]);
                    _b = __values(this.routes), _c = _b.next();
                    _h.label = 2;
                case 2:
                    if (!!_c.done) return [3 /*break*/, 5];
                    route = _c.value;
                    applyNewPath(route, basePath);
                    applyNewMeta(route, meta);
                    return [4 /*yield*/, route];
                case 3:
                    _h.sent();
                    _h.label = 4;
                case 4:
                    _c = _b.next();
                    return [3 /*break*/, 2];
                case 5: return [3 /*break*/, 8];
                case 6:
                    e_1_1 = _h.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 8];
                case 7:
                    try {
                        if (_c && !_c.done && (_f = _b.return)) _f.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 8:
                    _h.trys.push([8, 13, 14, 15]);
                    _d = __values(this.children), _e = _d.next();
                    _h.label = 9;
                case 9:
                    if (!!_e.done) return [3 /*break*/, 12];
                    child = _e.value;
                    child.mergeSharedData(this.shared);
                    return [5 /*yield**/, __values(child)];
                case 10:
                    _h.sent();
                    _h.label = 11;
                case 11:
                    _e = _d.next();
                    return [3 /*break*/, 9];
                case 12: return [3 /*break*/, 15];
                case 13:
                    e_2_1 = _h.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 15];
                case 14:
                    try {
                        if (_e && !_e.done && (_g = _d.return)) _g.call(_d);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 15: return [2 /*return*/];
            }
        });
    };
    RouteNode.prototype.mergeSharedData = function (parentShared) {
        var _a, _b;
        if (this.merged)
            return;
        var shared = this.shared;
        this.shared = {
            basePath: concatPaths((_a = parentShared.basePath) !== null && _a !== void 0 ? _a : "", (_b = shared.basePath) !== null && _b !== void 0 ? _b : ""),
            meta: shared.meta !== undefined ? shared.meta : parentShared.meta
        };
        this.merged = true;
    };
    return RouteNode;
}());
exports.RouteNode = RouteNode;
function applyNewPath(route, basePath) {
    var path = route.path;
    if (helpers_1.isString(path)) {
        route.path = concatPaths(basePath !== null && basePath !== void 0 ? basePath : "", path);
    }
}
function applyNewMeta(route, meta) {
    var _a;
    if (meta === void 0) { meta = {}; }
    if (route.meta === undefined) {
        route.meta = __assign({}, meta);
    }
    if (Array.isArray(route.children)) {
        (_a = route.children) === null || _a === void 0 ? void 0 : _a.forEach(function (child) { return applyNewMeta(child, meta); });
    }
}
function concatPaths(basePath, path) {
    if (!helpers_1.isString(basePath) || !helpers_1.isString(path)) {
        throw "basePath and path must be strings";
    }
    if (basePath[basePath.length - 1] === "/") {
        basePath = basePath.slice(0, basePath.length - 1);
    }
    if (path[0] === "/") {
        path = path.slice(1);
    }
    return basePath + "/" + path;
}
